import { decode, encode } from "js-base64";

import createNumberMask from "text-mask-addons/dist/createNumberMask";

export function ye(valor: string) {
  return encode(valor);
}

export function xd(valor: string) {
  return decode(valor);
}

export function showAlert(title: string, message: string) {}

export async function storage(key: string, value: string) {}

export async function recover(key: string): Promise<string | null> {
  return null;
}

export const maskCPF = [
  /[0-9]/,
  /\d/,
  /\d/,
  ".",
  /\d/,
  /\d/,
  /\d/,
  ".",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
];

export const maskData = [
  /[0-9]/,
  /\d/,
  "/",
  /\d/,
  /\d/,
  "/",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const maskCEP = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];

export const maskTelefone = [
  "(",
  /[0-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const maskCelular = [
  "(",
  /[0-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const maskMoney = createNumberMask({
  prefix: "R$ ",
  suffix: "",
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ".",
  allowDecimal: true,
  decimalSymbol: ",",
  decimalLimit: 2, // how many digits allowed after the decimal
  integerLimit: 5, // limit length of integer numbers
  allowNegative: false,
  allowLeadingZeroes: false,
});

export const currencyConfigMoney = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

// Convert file to base64 string
export async function fileToBase64(file: File): Promise<unknown> {
  const promise = new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.onload = function (event: any) {
      resolve(event.target.result);
    };
    reader.readAsDataURL(file);
  });
  return promise;
}
